import store from '../store'

const EosUtils = {
    isWebKartAdmin() {
        // debugger;
        var username = store.getters.getUserName;
        //console.log(username);
        if (username === 'eosWebKartAdmin') {
            return true
        } else {
            return false
        }
    },
    isWebKartAdmin1(bool) {
        // debugger;
        var username = store.getters.getUserName;
        //console.log(username);
        if (username === 'Admin') {
            bool=true;
            return bool
        } else {
            bool=false;
            return bool
        }
    },
    ConvertMinToHour(minutes) {
      
        if (minutes == 0) {
            return '00:00'
        }
        
        if (minutes) {
            debugger
            minutes = minutes.toString().replace('-', '')
            var h = Math.floor(minutes / 60);
            var m = minutes % 60;
            h = h < 10 ? '0' + h : h;
            m = m < 10 ? '0' + m : m;
            return h + ':' + m;
        }
        return '00:00'
    },
    ConvertHourMinToMin(input) {
        debugger;
        var arr = input.split(":");
        var hour = arr[0] === "" ? 0 : arr[0];
        var min = arr[1] === "" ? 0 : arr[1];
        var result = Math.round(hour) * 60 + Math.round(min);
        return result;
    },
    DecodeContent(input) {
        var output = ""
        output = Buffer.from(input, 'base64')
        return output
    },
    Log(text) {
        const fs = require('fs')
        fs.writeFile('/log/log.txt', text, err => {
            if (err) {
                console.error(err)
                return
            }
            //file written successfully
        })
    }
}

export default EosUtils;